import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Events, Classes, Elements } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});

			gsap.timeline({
				scrollTrigger: {
					start: -1,
					end: 10,
					toggleClass: {
						targets: document.body,
						className: 'on-top'
					},
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Header ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.mobile.min.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 0,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === 1 && !$Elements.body.hasClass(Classes.menuWineRangeOpen)) ? this.classList.add('shrink') : this.classList.remove('shrink');
					}
				}
			});

			gsap.timeline({
				scrollTrigger: {
					start: () => $('.content-section:first-child').height(),
					onEnter: () => $Elements.body.addClass('menu-light'),
					onLeaveBack: () => $Elements.body.removeClass('menu-light')
				}
			});

			gsap.timeline({
				scrollTrigger: {
					start: 0,
					end: () => $('.content-section:first-child').height() + ($(this).height() * 2),
					toggleClass: {
						targets: this,
						className: 'force-shrink'
					}
				}
			});
		});

		Animations.mobile.max.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					onEnter: () => $Elements.body.addClass('menu-light'),
					onLeaveBack: () => $Elements.body.removeClass('menu-light')
				}
			});
		});
	});

	// ---------- Menu Anchors Pin ----------

	$('#menu-anchors-section').each(function() {

		Animations.mobile.min.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top top',
					endTrigger: Elements.FooterWrapper,
					end: 'bottom top',
					pin: true,
					pinSpacing: false,
				}
			});
		});
	});

	// ---------- CTA fix - Remove on page bottom ----------

	$('#cta-fix-section').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: Elements.FooterWrapper,
					start: 'top bottom',
					endTrigger: Elements.FooterWrapper,
					end: 'bottom top',
					toggleClass: { targets: this, className: "disappear" }
				}
			});
		});
	});

	// ---------- Parallax Text - images ----------

	$('.parallax-text-images-section .text-column .content').each(function() {

		Animations.sm.min.push(() => {

			const leftImage = this.querySelector(':scope .left-image');

			if(leftImage) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(leftImage, {
					yPercent: 20
				}, {
					yPercent: -20
				});
			}

			const rightImage = this.querySelector(':scope .right-image');

			if(rightImage) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(rightImage, {
					yPercent: -20
				}, {
					yPercent: 20
				});
			}
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
